import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { RechargeBillingComment } from "__generated__/enums";

const RechargeBillingCommentSelect = ({
	...rest
}: Omit<SelectProps<RechargeBillingComment, false>, "getOptionLabel" | "fetchOptions" | "paginated" | "disableSearch">) => (
	<Select
		{...rest}
		getOptionLabel={option => intl.formatMessage({ id: `RECHARGE_COMMENT_${option}` })}
		fetchOptions={Object.values(RechargeBillingComment)}
		disableSearch />
);

export default RechargeBillingCommentSelect;
